import { oneLine } from 'common-tags';
import { formatCurrency } from 'common/FormatUtilities';
import { Tooltip } from 'src/shared/design-system/Tooltip';
import { Line, Text, TextContainer } from './styles';

export const ShefTipLine = ({ shefTip }: { shefTip: number | null }) => {
  const tooltip = oneLine`
    100% of this tip will go to your Shef. Percentages are calculated
    from your order total before discounts and delivery fees.
  `;

  return shefTip ? (
    <Line>
      <TextContainer>
        <Text>Shef Tip</Text>
        <Tooltip content={tooltip} showInfoCircle positions={['right', 'top', 'bottom', 'left']} />
      </TextContainer>
      <Text>{formatCurrency(shefTip)}</Text>
    </Line>
  ) : null;
};
